<template>
	<div id="operationType-table">
		<table class="table" v-if="tableRows.length != 0 && !isLoadingOperations">
			<thead class="table__header">
				<tr>
					<th
						v-for="(header, index) in tableHeader"
						@click="orderByHeader(header)"
						:class="header.field == 'edit' || header.field == 'delete' ? 'icon' : ''"
						:key="index"
					>
						<div class="row">
							<span :class="header.field == 'actions' ? '' : 'pointer'">{{ header.label }}</span>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(row, index) in tableRows"
					:key="`${row.id}_${row.language}`"
					:class="[index % 2 == 0 ? 'stripped' : '', row.isInvalid ? 'invalid' : '']"
				>
					<td>{{ row.name }}</td>
					<td>{{ row.language }}</td>
					<td class="actions">
						<span @click="editRow(row)"><EditIcon :size="24" :border="'#0047ff'" /></span>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="loader" v-if="isLoadingOperations">
			<SpinnerIcon :color="'#597393'" />
		</div>
		<Pagination
			v-if="tableRows.length != 0 && !isLoadingOperations"
			:totalPages="totalPages"
			:currentFromReq="currentPage"
			@tableRequest="tableRequest"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import Pagination from '@/components/shared/Pagination/Pagination';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon';
import EditIcon from '@/components/shared/Icons/EditIcon.vue';

export default {
	name: 'Table',
	components: {
		SidebarArrow,
		Pagination,
		SpinnerIcon,
		EditIcon,
	},
	props: {
		isWeb: {
			required: true,
		},
		currentPage: {
			required: true,
		},
	},
	data: () => ({}),
	mounted() {},
	methods: {
		formatCnpj(param) {
			let cpnj = param.replace(/[^\w\s]/gi, '');
			return cpnj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
		},
		tableRequest(param) {
			this.$emit('changePage', param);
		},
		orderByHeader(param) {
			if (param.field == 'actions') return;
			this.$emit('orderByHeader', param.field);
		},
		editRow(row) {
			this.$router.push({
				path: '/dashboard/config/operationType/detail',
				query: { id: row.id },
			});
		},
	},
	computed: {
		...mapGetters('operationTypeManagement', ['operationsList', 'isLoadingOperations']),
		tableHeader() {
			return [
				{
					field: 'name',
					label: 'Nome',
				},
				{
					field: 'language',
					label: 'Idioma',
				},
				{
					field: 'actions',
					label: 'Ações',
				},
			];
		},
		tableRows() {
			const rows =
				this.operationsList.operationTypes != undefined ? this.operationsList.operationTypes : [];

			return !rows.length ? [] : rows;
		},
		totalPages() {
			const pagination =
				this.operationsList.totalPages != undefined ? this.operationsList.totalPages : 1;

			return pagination;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'Table.scss';
</style>
